import { createFragmentContainer, graphql } from 'react-relay';
import LinkComponent from './LinkComponent';

export default createFragmentContainer(LinkComponent, {
  viewer: graphql`
    fragment LinkContainer_viewer on User {
      id
      embed_token
      s_recaptcha_enabled
      s_recaptcha_site_key
      s_recaptcha_secret_key
      phones {
        edges {
          node {
            id
            number
            verified
          }
        }
      }
      s_text_on_embed_submit
      ...AvailabilityCheckerContainer_viewer
    }
  `,
});



// WEBPACK FOOTER //
// ./webpack/components/Leads/LinkContainer.js